'use client';
import NotFoundPage from '@/features/not-found/components/NotFound';
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <>
      {/* ================> 404 section start here <================== */}
      <NotFoundPage error={error} reset={reset} />
      {/* ================> 404 section end here <================== */}
    </>
  );
}
